






































import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'NewsItem'

    props: ['document']

    components:
        DocumentLink: DocumentLink

    data: ->
        fields: @defaultFields()

    computed:
        localDate: -> new Date(@fields.date).toLocaleDateString() + ''

    methods:
        defaultFields: ->
            image: []
            title: []
            subtitle: []
            text: []
            button_title: []
            button_link: []

        setContent: (document) ->
            fields =
                date: document.date
                image: document.image
                title: document.title
                subtitle: document.subtitle
                text: document.text
                button_title: document.button_title
                button_link: document.button_link
            $.extend @fields, fields

    created: ->
        @setContent @document
}
